import { defineComponent as n, computed as l, openBlock as i, createElementBlock as a, createElementVNode as e, toDisplayString as d, createCommentVNode as h, normalizeStyle as f } from "vue";
const _ = ["viewBox"], v = /* @__PURE__ */ e("mask", { id: "ffb8a2e0-d65a-431e-80b5-27d87a883473" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#ffb8a2e0-d65a-431e-80b5-27d87a883473)" }, m = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M0 0h100.2l68.3 40.7L233.7 0H512v189.2l-45.5 66 45.5 68.6V512H233.7l-65.8-39.2-67.7 39.2H0V322.8l45.6-67.5L0 189.2z"
}, null, -1), p = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M100.2 0v189.2H0v33.4l23 34-23 32.8v33.4h100.2V512h33.4l33.9-22.6 32.8 22.6h33.4V323.8H512v-34.4l-24.2-32.2 24.2-34.6v-33.4H233.7V0h-33.4l-32.6 20-34.1-20z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M133.6 0v222.6H0v66.8h133.6V512h66.7V289.4H512v-66.8H200.3V0h-66.7z"
}, null, -1), V = { fill: "none" }, x = ["r"], W = /* @__PURE__ */ n({
  __name: "ax",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, o = l(() => 512 + 2 * t.strokeWidth), s = l(() => -t.strokeWidth), c = l(() => 256 + t.strokeWidth / 2);
    return (H, w) => (i(), a("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${o.value} ${o.value}`
    }, [
      v,
      e("g", u, [
        t.flagName ? (i(), a("title", m, d(t.flagName), 1)) : h("", !0),
        k,
        p,
        g
      ]),
      e("g", V, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: c.value,
          fill: "none",
          style: f({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, _));
  }
});
export {
  W as default
};
//# sourceMappingURL=ax-c6f18413.js.map
